import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect, useState } from 'react';
import { array, node, object, oneOfType, string, func, bool, element } from 'prop-types';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { Container, ContainerText, ContainerTextPrice, ProductImageContainer, ProductImage } from './list-suggestions-item.style';
import { buildHighlightedQuery } from './helpers/index';

const ListSuggestionItem = _ref => {
  let {
    item,
    term,
    desktopMode,
    onSearchSubmit
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["item", "term", "desktopMode", "onSearchSubmit"]);

  const [query, setQuery] = useState(term);
  useEffect(() => {
    setQuery(term);
  }, [term]);
  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "suggestion-item",
    key: item.count || item.id,
    onClick: onSearchSubmit,
    desktopMode: desktopMode
  }, props), item.img && /*#__PURE__*/React.createElement(ProductImageContainer, null, /*#__PURE__*/React.createElement(ProductImage, {
    src: item.img
  })), props.prefix && !item.img ? props.prefix : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ContainerText, _extends({
    "data-testid": "suggestion-text",
    desktopMode: desktopMode
  }, props), buildHighlightedQuery({
    query,
    suggestionItem: item
  }), desktopMode && item.count ? ` (${item.count})` : ''), item.price && /*#__PURE__*/React.createElement(ContainerTextPrice, {
    "data-testid": "suggestion-price"
  }, currencyFormatter({
    value: item.price
  }))));
};

export default ListSuggestionItem;
process.env.NODE_ENV !== "production" ? ListSuggestionItem.propTypes = {
  item: oneOfType([array, object, node]),
  term: string.isRequired,
  desktopMode: bool,
  prefix: oneOfType([string, element]),
  borderBottom: bool,
  onSearchSubmit: func
} : void 0;
ListSuggestionItem.defaultProps = {
  item: {},
  desktopMode: false,
  borderBottom: false,
  onSearchSubmit: null
};